import React, { useEffect } from "react";
import { RouteProps, useNavigate, useParams } from "react-router-dom";

import { Helmet } from "react-helmet-async";
import ReturnSpecificCases from "../tools/RoutesTools";
import CpntPage from "../components/CpntPage";
import { IBreadCrumbs } from "../models/interfaces/IBreadCrumbs";
import { useKeycloak } from "@react-keycloak/web";
import { KeyCloakRoles } from "../config/helpers";
import { RootState } from "../redux/store";
import { useSelector } from "react-redux";

type PrivateRouteProps = RouteProps & {
  component: React.ComponentType<any>;
  ReturnPath?: string;
  ReturnPathAlt?: string;
  ReturnTitle?: string;
  ReturnClass?: string;
  BreadCrumbs?: IBreadCrumbs[];
  indexSEO?: boolean;
  ModuleNeeded?: number;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ReturnPath,
  ReturnPathAlt,
  ReturnTitle,
  ReturnClass,
  BreadCrumbs,
  indexSEO,
  ModuleNeeded,
  ...rest
}) => {

  const navigate = useNavigate();
  const { initialized:keycloakinitialized,keycloak } = useKeycloak();
  const compte = useSelector((state: RootState) => state.compte);
  const params = useParams();

  useEffect(() => {
    if (keycloakinitialized) {
      if (!keycloak.authenticated || compte.Connected === false ) {
        //PrivateRoute : pas auth
        navigate("/");
      } else if ((keycloak.authenticated && keycloak?.hasRealmRole(KeyCloakRoles.ElectreBO.toString()))) {
        //keycloak.logout();
        navigate("/admin/accueil");
      } else if (ModuleNeeded && compte?.Connected && (!compte?.Modules?.includes(ModuleNeeded))) {
        navigate("/");
      } else {
        //PrivateRoute : auth
      }
    }
   }, [keycloakinitialized,keycloak.authenticated,compte])
  

  return (
  <>
          {indexSEO === false && (
            <Helmet>
              <meta name="robots" content="noindex" />
            </Helmet>
          )}
          <CpntPage
            ReturnPath={ReturnSpecificCases({ ReturnPath, ReturnPathAlt, params })}
            ReturnTitle={ReturnTitle}
            ReturnClass={ReturnClass}
            BreadCrumbs={BreadCrumbs}
          >
            <Component />
          </CpntPage>
        </>
  );
}

export default PrivateRoute;